import inicio from '../content/ajuda/inicio.md?raw';
import manual from '../content/ajuda/manual.md?raw';
import cadastros from '../content/ajuda/cadastros.md?raw';
import pedido from '../content/ajuda/pedido.md?raw';
import recebimento from '../content/ajuda/recebimento.md?raw';
import producao from '../content/ajuda/producao.md?raw';
import apontamento from '../content/ajuda/apontamento.md?raw';
import expedicao from '../content/ajuda/expedicao.md?raw';
import pecas from '../content/ajuda/pecas.md?raw';
import tratamentos from '../content/ajuda/tratamentos.md?raw';
import tintas from '../content/ajuda/tintas.md?raw';
import planejamento from '../content/ajuda/planejamento.md?raw';
import qualidade from '../content/ajuda/qualidade.md?raw';
import estoque from '../content/ajuda/estoque.md?raw';
import compras from '../content/ajuda/compras.md?raw';
import relatorios from '../content/ajuda/relatorios.md?raw';
import acessos from '../content/ajuda/acessos.md?raw';

export interface ArtigoAjuda {
  readonly id: string;
  readonly titulo: string;
  readonly resumo: string;
  readonly texto: string;
  readonly rotas: readonly string[];
}

function artigo(id: string, markdown: string, rotas: readonly string[]): ArtigoAjuda {
  const [cabecalho = '', ...linhas] = markdown.trim().split('\n');
  const texto = linhas.join('\n').trim();
  return { id, titulo: cabecalho.replace(/^# /, '').trim(), resumo: texto.split('\n\n')[0] ?? '', texto, rotas };
}

// O mesmo Markdown alimenta a busca, a central e a ajuda contextual; poderá alimentar os PDFs.
export const ARTIGOS_AJUDA: readonly ArtigoAjuda[] = [
  artigo('inicio', inicio, []),
  artigo('manual', manual, []),
  artigo('cadastros', cadastros, ['/cadastros', '/pcp/roteiros', '/omie/clientes']),
  artigo('pecas', pecas, ['/cadastros/pecas']),
  artigo('tratamentos', tratamentos, []),
  artigo('tintas', tintas, ['/pcp/roteiros/tintas', '/estoque/consumo-tinta', '/coletor/tinta']),
  artigo('pedido', pedido, ['/vendas/pedidos', '/vendas/precos']),
  artigo('recebimento', recebimento, ['/remessas', '/pcp/recebimentos', '/pendencias']),
  artigo('producao', producao, ['/producao']),
  artigo('planejamento', planejamento, ['/planejamento', '/coletor/kanban']),
  artigo('apontamento', apontamento, ['/coletor']),
  artigo('qualidade', qualidade, ['/qualidade']),
  artigo('estoque', estoque, ['/estoque']),
  artigo('compras', compras, ['/compras']),
  artigo('expedicao', expedicao, ['/expedicao', '/omie/pendencias']),
  artigo('relatorios', relatorios, ['/relatorios', '/monitoramento', '/painel']),
  artigo('acessos', acessos, ['/admin', '/cadastros/acessos-portal', '/coletor/kanban/configurar']),
];

export function ajudaDaTela(pathname: string): ArtigoAjuda {
  const caminho = pathname.split(/[?#]/)[0] ?? pathname;
  // Um guia específico (tintas, peças, configuração do tablet) prevalece sobre o módulo.
  let escolhido = ARTIGOS_AJUDA[0]!;
  let tamanho = 0;
  for (const item of ARTIGOS_AJUDA) {
    for (const rota of item.rotas) {
      if (rota.length > tamanho && (caminho === rota || caminho.startsWith(`${rota}/`))) {
        escolhido = item;
        tamanho = rota.length;
      }
    }
  }
  return escolhido;
}

function normalizar(texto: string): string {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR');
}

export function buscarAjuda(busca: string): readonly ArtigoAjuda[] {
  const termos = normalizar(busca).trim().split(/\s+/).filter(Boolean);
  return ARTIGOS_AJUDA.filter((item) => {
    const texto = normalizar(`${item.titulo} ${item.texto}`);
    return termos.every((termo) => texto.includes(termo));
  });
}

export type BlocoAjuda = { readonly tipo: 'titulo' | 'subtitulo' | 'paragrafo'; readonly texto: string }
  | { readonly tipo: 'lista' | 'passos'; readonly itens: readonly string[] };

/** Subconjunto editorial: títulos, parágrafos e listas. HTML e links não são executados. */
export function blocosAjuda(texto: string): readonly BlocoAjuda[] {
  return texto.trim().split(/\r?\n\s*\r?\n/).filter(Boolean).map((bloco) => {
    if (bloco.startsWith('### ')) return { tipo: 'subtitulo', texto: bloco.slice(4) };
    if (bloco.startsWith('## ')) return { tipo: 'titulo', texto: bloco.slice(3) };
    const linhas = bloco.split(/\r?\n/);
    if (linhas.every((linha) => /^- /.test(linha))) return { tipo: 'lista', itens: linhas.map((linha) => linha.slice(2)) };
    if (linhas.every((linha) => /^\d+\. /.test(linha))) return { tipo: 'passos', itens: linhas.map((linha) => linha.replace(/^\d+\. /, '')) };
    return { tipo: 'paragrafo', texto: linhas.join(' ') };
  });
}
